import { Icon, Tooltip } from "@deligoo/ui"
import clsx from "clsx"
import dayjs from "dayjs"
import { useTranslation } from "react-i18next"
import { shallowEqual } from "react-redux"

import { useAppSelector } from "@/App"
import { WeatherIcon } from "@/components/WeatherIcon"
import { selectCurrentTeamStats, selectTeamsStatsStatus } from "@/store/teamsStats"
import { TeamStats } from "@/types"
import { getTrafficValueColor } from "@/utils"

import cls from "../MapView.module.scss"

export const MapTeamStats = ({ displayOnlyOnMobile = false }) => {
  const teamStats = useAppSelector(selectCurrentTeamStats, shallowEqual)
  const teamStatsStatus = useAppSelector(selectTeamsStatsStatus)
  const date = useAppSelector((state) => state.global.date)

  const { t } = useTranslation()

  if (!teamStats || teamStatsStatus !== "fetched" || !dayjs(date).isToday()) return null

  return (
    <div className={clsx(displayOnlyOnMobile ? cls.mobileValues : cls.values)}>
      {teamStats.traffic_value !== null && (
        <Tooltip content={t("traffic_value")}>
          <div className={cls.value}>
            <Icon name="traffics" className={cls.icon} color={getTrafficValueColor(teamStats.traffic_value)} />
            {teamStats.traffic_value}%
          </div>
        </Tooltip>
      )}

      <Tooltip content={t("load_value")}>
        <div className={cls.value}>
          <Icon name="boxes" className={cls.icon} color={getLoadValueColor(teamStats.load_value)} />
          {teamStats.load_value.toFixed(2)}
        </div>
      </Tooltip>

      <Tooltip content={t("dynamic_buffer_real_value")}>
        <div className={cls.value}>
          <Icon
            name="delivery-time"
            className={cls.icon}
            color={getBufferRealValueColor(teamStats.dynamic_buffer_real_value)}
          />
          {teamStats.dynamic_buffer_real_value} min.
        </div>
      </Tooltip>

      <WeatherIcon weather={teamStats.weather} className={cls.value} />
    </div>
  )
}

function getLoadValueColor(value: TeamStats["load_value"]) {
  if (value <= 1.8) return "success"
  if (value <= 2.55) return "warning"
  if (value <= 2.97) return "alert"

  return "danger"
}

function getBufferRealValueColor(value: number) {
  if (value <= 40) return "success"
  if (value <= 60) return "warning"

  return "alert"
}
